import React, { Component } from 'react';
import Slider from 'rc-slider';

class DataSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.threshold,
      min: 0,
      max: 50
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.threshold !== this.props.threshold) {
      this.setState({
        value: this.props.threshold
      });
    }
  }

  handleChange = e => {
    this.setState({ value: e });
  };

  handleAfterChange = e => {
    this.props.changeThreshold(e);
  };

  decrease = () => {
    let value = this.state.value - 1;
    if (value < this.state.min) {
      return false;
    }

    this.setState({ value });
    this.handleAfterChange(value);
  };

  increase = () => {
    let value = this.state.value + 1;
    if (value > this.state.max) {
      return false;
    }

    this.setState({ value });
    this.handleAfterChange(value);
  };

  render() {
    return (
      <div className="slider-control">
        <div className="slider-values">
          <button
            className="btn slider-step"
            disabled={this.state.value === this.state.min}
            onClick={this.decrease}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6" /></svg>
          </button>
          <span className="slider-value">{this.state.value} %</span>
          <button
            className="btn slider-step"
            disabled={this.state.value === this.state.max}
            onClick={this.increase}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6" /></svg>
          </button>
        </div>
        <div className="slider-track">
          <Slider
            min={this.state.min}
            max={this.state.max}
            value={this.state.value}
            onChange={this.handleChange}
            onAfterChange={this.handleAfterChange}
          />
        </div>
      </div>
    );
  }
}

export default DataSlider;
